<template>
  <div class="shopping-container publicList_box">
    <div class="carousel-box" v-if="!fromListing">
      <!--侧边栏分类区域-->
      <div class="left-classification">
        <div class="meun_title_box" v-if="showBoxTalg">
          <Icon type="md-menu" size="26" color="#89b92a" class="ml12" style="position: relative; top: 2px;"/>
          <p class="meun_title">{{ $t('key1000012') }}</p>
        </div>
        <div class="category-panel">
          <trsCategoryTree
            :sourceData="menuList"
            :defaultSelectedValue="defaultCategoryId"
            @select="toListBtn"
          />
        </div>
      </div>
      <!--右边轮播图、个人信息区域-->
      <div class="right-information">
        <!--活动tab栏-->
        <activityTab v-if="showBoxTalg"></activityTab>
        <div class="flex align-items-end justify-content-between">
          <div class="carousel-map">
            <!--轮播图区域-->
            <div class="rotationChart_box">
              <Carousel v-model="carouselTalg"
                :autoplay="setting.autoplay"
                :autoplay-speed="setting.autoplaySpeed"
                :dots="setting.dots"
                :radius-dot="setting.radiusDot"
                :trigger="setting.trigger"
                :loop="setting.loop"
                @on-click="changeCarousel"
                :arrow="setting.arrow">
                <CarouselItem v-for="(item,index) in carouselList" :key="index">
                  <img class="banner_img" :src="item.imagePath"/>
                </CarouselItem>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--商品推荐列表-->
    <div class="recommend_box">
      <div class="recommend_box_item" :class="[4,6].includes(item.type) ? 'recommend_box_set' : ''"
        v-for="(item, index) in commodityList" :key="index">
        <div class="recommend_title">
          <h2 class="title">{{ item.title }}</h2>
          <div class="flex align-items hoverStyles">
            <span class="text" @click="moreBtn(item)">{{ $t('key1000106') }}</span>
            <Icon size="16" class="forward_icon_styles" type="ios-arrow-forward"/>
          </div>
        </div>
        <div class="recommend_content">
          <div class="recommend_content_item" v-for="(ele,idx) in item.list" :key="idx">
            <div @click="gotoPath(`/shopDetails/${ele.ymsProductId}`)">
              <div class="img_box_styles">
                <image-box :src="getThumbnailImage(ele.primaryImage)" :animation="true"></image-box>
              </div>
              <p class="title" :title="ele.name">{{ ele.name }}</p>
              <template v-if="userInfo || showPricesTalg">
                <!--折扣价-->
                <template v-if="userInfo && ele.freightDiscount !==1">
                  <p class="flex align-items-center justify-content-between">
                    <span class="price">{{ currencyState + currencySymbol(currencyState) + ele.minPrice }}</span>
                    <span class="original_price_style">{{ currencyState + currencySymbol(currencyState) + ele.minSuggestPrice }}</span>
                  </p>
                  <!--标签-->
                  <div class="activity_label_box" v-if="ele.activityGoodsLabelList">
                    <template v-for="talg in ele.activityGoodsLabelList">
                      <span class="activity_label_item" v-if="talg" style="background-color: #FF1810;">{{ talg }}</span>
                    </template>
                  </div>
                </template>
                <!--销售价-->
                <template v-if="ele.freightDiscount === 1 && showPricesTalg">
                  <p class="price">
                    {{
                      (currencyState ? currencyState : ele.currency) +
                      currencySymbol(currencyState ? currencyState : ele.currency) +
                      ele.minPrice
                    }}
                  </p>
                </template>
              </template>
              <p class="price" v-else>{{ $t('key1006651') }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';


import imageBox from '@/components/common/imageBox';
import api from '@/api/';
import commonMixin from '@/components/mixin/common_mixin';
import activityTab from "@/components/common/activityTab";
import {getAdidToken, setAdidToken} from "@/utils/cookie";
import {advertisingLinkAddress, pageJump, getHrefPath, amountHandel, getQueryString, commonLocalStorage} from "@/utils/common";
import TrsCategoryTree from "@/components/layout/shopping/common/trsCategoryTree.vue";

export default {
  name: 'ymsIndex',
  data() {
    return {
      carouselTalg: 0,
      setting: {
        autoplay: false,
        autoplaySpeed: 4000,
        dots: 'outside',
        radiusDot: true,
        trigger: 'click',
        arrow: 'always',
        loop: true
      },
      headPortraitUrl: require('@/assets/images/headPortrait.png'),
      orderInfo: {
        isShippedQuantity: 0,
        shippedQuantity: 0,
        pendingQuantity: 0
      },
      commodityList: [],
      jumpTargetObj: null,
      adid: null,
      showPricesTalg: false, // 默认不展示价格
      defaultCategoryId: null
    };
  },
  mixins: [commonMixin],
  computed: {
    welcomeMessageText() {
      let pageConfig = commonLocalStorage.getItem('pageConfig') || this.$store.state.pageConfig;
      let sname = pageConfig.sname || '';
      return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000085')}${sname}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000086')}`;
    },
    fromListing() {
      return this.$store.state.fromListing
    },
    menuList() {
      return this.$store.state.classificationData;
    },
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    // 是否隐藏频道tab栏
    showBoxTalg() {
      let tlag = this.$store.state.navBarFixed;
      this.$store.commit('showHover', tlag);
      return !tlag;
    },
    // 金刚区的数据
    vajraDistrictList() {
      let advertisingList = this.$store.state.mallAdvertising;
      let list = [];
      if (advertisingList && advertisingList.length > 0) {
        advertisingList.map((item) => {
          if (item.orientationType === 4) {
            list = item.ymsAdvertisementDetailBos;
          }
        });
      }
      return list;
    },
    // 首页-个人信息下方广告位
    infoAdvertisingImg() {
      let advertisingList = this.$store.state.mallAdvertising;
      let imagePath = '';
      if (advertisingList && advertisingList.length > 0) {
        advertisingList.map((item) => {
          if (item.orientationType === 2) {
            if (item.status) {
              imagePath = item.ymsAdvertisementDetailBos[0].imagePath;
              this.jumpTargetObj = item.ymsAdvertisementDetailBos[0];
            }
          }
        });
      }
      return imagePath;
    },
    // 轮播图数据
    carouselList() {
      let advertisingList = this.$store.state.mallAdvertising;
      let list = [];
      if (advertisingList && advertisingList.length > 0) {
        advertisingList.map((item) => {
          if (item.orientationType === 1) {
            list = item.ymsAdvertisementDetailBos.filter((ele) => {
              return ele.imagePath
            });
          }
        });
      }
      return list;
    },
    // 是否展示售卖国
    showProductSaleCountrySet() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return Number(obj?.enableProductSaleCountrySet) === 1;
    },
    // 商城游客价格展示配置
    touristPriceConfig() {
      const obj = commonLocalStorage.getItem('configurationItemInfo') ?? this.$store.state.configurationItemInfo;
      return obj?.touristPriceConfig;
    }
  },
  created() {
    if (Object.keys(this.userInfo).length > 0) {
      this.showPricesTalg = true;
    } else {
      this.showPricesTalg = this.touristPriceConfig !== 'hidePrice';
    }
    this.incidentReporting();
    this.getListData();
  },
  mounted() {
    if (!localStorage.getItem('noFirstEntry') && this.systemEnvironment === 'yms') {
      this.$parent.$refs.gettingStarted.open();
    }
    if (this.$store.state.erpConfig) {
      this.getStatistics();
    }

  },
  methods: {
    advertisingLinkAddress,
    // 获取商户订单信息
    getStatistics() {
      let v = this;
      v.axios.get(api.get_ymsDistributorPackageInfo_queryStatusStatistics).then((response) => {
        if (response.data.code === 0) {
          v.orderInfo = response.data.datas;
        }
      });
    },
    // 跳转到商城详情页
    gotoPath(path) {
      if (this.fromListing) {
        this.$router.push({
          path: path
        });
      } else {
        pageJump('/index.html#' + path, '/yms-shopping-service', '_blank')
      }
    },
    // 免费注册
    register() {
      pageJump('/login.html#/register', '/yms-shopping-service', '_blank');
    },
    // 登录
    login() {
      let url = '/login.html#/login';
      let service = '/yms-shopping-service';
      let type = '_self'; // 在当前窗口打开, _blank 在新窗口打开
      let links = '?u=' + window.location.href;
      pageJump(url, service, type, links);
    },
    // 获取列表数据
    getListData() {
      let v = this;
      v.commodityList = [];
      let countryCode = v.showProductSaleCountrySet ? (commonLocalStorage.getItem('sellingCountry') || 'CN') : 'CN';
      let ymsDeliveryPlaceId = commonLocalStorage.getItem('ymsDeliveryPlaceId');
      let baseUrl = api.get_ymsProductInfo_shopping_queryForShowCase;
      let queryParams = [`ymsDeliveryPlaceId=${ymsDeliveryPlaceId}`];
      if (v.userInfo.merchantId) {
        queryParams.push(`distributorMerchantId=${v.userInfo.merchantId}`);
      }
      if (v.showProductSaleCountrySet) {
        queryParams.push(`countryCode=${countryCode}`);
      }
      let url = queryParams.length > 0 ? `${baseUrl}?${queryParams.join('&')}` : baseUrl;
      v.axios.get(url).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          let typeList = [
            {type: 6, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006645')},
            {type: 4, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006646')},
            {type: 1, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006647')},
            {type: 2, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006648')},
            {type: 3, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006649')},
            {type: 5, title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006650')}
          ];
          // 建立完整映射
          const typeMap = {};
          typeList.forEach((item, index) => {
            typeMap[item.type] = {
              ...item,
              order: index
            };
          });
          // 排序
          data.sort((a, b) => {
            return (typeMap[a.type]?.order ?? 999) - (typeMap[b.type]?.order ?? 999);
          });
          // 处理数据
          data.forEach(item => {
            const typeConfig = typeMap[item.type];
            if (!typeConfig) return;
            item.title = typeConfig.title;
            item.list = item.queryYmsProductInfoForShoppingResultBos || [];
            item.list.forEach(talg => {
              let prices = [
                talg.activityPrice,
                talg.minSuggestPrice
              ];
              if (talg.freightDiscount !== 1) {
                prices.push(talg.minFreightDiscountPrice);
                talg.activityGoodsLabelList = [aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000981')];
              }
              const validPrices = prices.filter(v => v != null);
              const minPrice = Math.min(...validPrices);
              talg.minPrice = amountHandel(minPrice);
              talg.minSuggestPrice = amountHandel(talg.minSuggestPrice);
            });
          });
          data.map((item) => {
            if ([4, 6].includes(item.type)) {
              item.list = item.list.slice(0, 6) || [];
            }
          });
          v.commodityList = data;
        }
      });
    },
    // 点击更多按钮跳转到商品列表
    moreBtn(item) {
      if (item.ymsProductCategoryId) {
        if (this.fromListing) {
          window.location.href = getHrefPath(`/index.html#/shopList?ymsProductCategoryId=${item.ymsProductCategoryId}&commodityType=${item.type}`, '/yms-shopping-service');
        } else {
          pageJump(`/index.html#/shopList?ymsProductCategoryId=${item.ymsProductCategoryId}&commodityType=${item.type}`,
            '/yms-shopping-service', '_blank');
        }
      } else {
        if (this.fromListing) {
          window.location.href = getHrefPath(`/index.html#/shopList?activityTitle=${item.title}&commodityType=${item.type}`,
            '/yms-shopping-service',);
        } else {
          pageJump(`/index.html#/shopList?activityTitle=${item.title}&commodityType=${item.type}`,
            '/yms-shopping-service', '_blank');
        }

      }
    },
    // 跳转到列表页
    toListBtn(data) {
      this.$router.push({
        path: '/shopList',
        query: {
          ymsProductCategoryId: data.ymsProductCategoryId
        }
      });
    },
    // 点击banner进入活动列表
    changeCarousel(index) {
      let v = this;
      v.carouselList.map((item, idx) => {
        if (index === idx) {
          advertisingLinkAddress(item);
        }
      });
    },
    // 跳转到帮助中心
    helpCenterUrl(id, type, target) {
      let url = '';
      if (id) {
        url = `/index.html#/help?id=${id}`;
        let service = '/yms-shopping-service';
        let link = getHrefPath(url, service);
        this.axios.get(api.get_helpCenterDocs_increaseViewsQuantity + `?docsId=${id}`).then(response => {
          if (response.data.code === 0) {
            window.open(link, target);
          }
        });
      }
      if (type) {
        url = `/index.html#/help?type=${type}`;
        let service = '/yms-shopping-service';
        let link = getHrefPath(url, service);
        window.open(link, target);
      }
    },
    // 商城首页埋点及事件上报(TMS跳转到yms商城页面携带有adid参数时才触发)
    incidentReporting() {
      let v = this;
      v.adid = null;
      let urlAdid = getQueryString('adid');
      let adidToken = getAdidToken('adidToken');
      let adid = urlAdid || adidToken;
      if (urlAdid || adidToken) {
        let query = {
          adid: adid
        }
        v.axios.post(api.post_ymsDistributorMerchant_tokerLinkEventReport, query).then(response => {
          if (response.data.code === 0) {
            v.adid = adid;
            if (urlAdid) {
              setAdidToken(adid)
            }
          }
        });
      }
    }
  },
  watch: {
    // 监听售卖国
    '$store.state.updateSellingCountry': {
      handler(val) {
        let v = this;
        if (val) {
          setTimeout(() => {
            v.getListData();
          }, 500);
        }
      },
      deep: true
    },
    // 监听商品发货地
    '$store.state.updatePlaceOfShipment': {
      handler(val) {
        let v = this;
        if (val) {
          setTimeout(() => {
            v.getListData();
          }, 500);
        }
      },
      deep: true
    },
  },
  components: {
    TrsCategoryTree,

    imageBox,
    activityTab
  }
};
</script>

<style>
.ivu-carousel-track, .ivu-carousel-list {
  height: 100%;
}

.ivu-carousel-list .ivu-carousel-item {
  overflow: hidden;
}

.ivu-carousel-dots-outside {
  position: absolute;
  bottom: 6px;
}

.ivu-carousel-track + .ivu-carousel-track {
  margin-left: -1px !important;
}
</style>

<style lang="less" scoped>
@import "src/assets/styles/shopping/common";

.carousel-box {
  display: flex;
  justify-content: space-between;

  .left-classification {
    width: 280px;
    background-color: #EFF0F5;
    z-index: 100;

    .meun_title_box {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      background-color: #fff;

      .meun_title {
        font-size: 17px;
        font-family: PingFang SC;
        font-weight: bold;
        padding-left: 12px;
        height: 40px;
        line-height: 40px;
        color: #89b92a;
      }
    }
  }

  .right-information {
    min-height: 370px;
    width: 912px;
    background-color: #EFF0F5;

    .carousel-map {
      width: 912px;
      box-sizing: border-box;

      .rotationChart_box {
        width: 912px;
        height: 324px;
        cursor: pointer;
        margin-bottom: 8px;
        background: #FFFFFF;
        border-radius: 4px;
        overflow: hidden;

        /deep/ .ivu-carousel {
          width: 100%;
          height: 100%;

          .ivu-carousel-dots-inside {
            bottom: 18px;
          }

          .radius {
            width: 8px;
            height: 8px;
          }

          .ivu-carousel-active {
            .radius {
              background-color: #FD5425;
            }
          }

          .ivu-carousel-arrow {
            width: 24px;
            height: 32px;
            background: #000000;
            opacity: 0.4;
            display: flex;
            justify-content: center;
            align-items: center;

            .ivu-icon {
              font-size: 22px;
              color: #fff;
            }
          }

          .ivu-carousel-arrow.right {
            right: 0;
            border-radius: 4px 0px 0px 4px;
          }

          .ivu-carousel-arrow.left {
            border-radius: 0px 4px 4px 0px;
            left: 0;
          }
        }

        .banner_img {
          display: inline-block;
          width: 100%;
          height: 100%;
        }
      }

      .main_classification_box {
        width: 100%;
        height: 128px;
        background: #FFFFFF;
        border-radius: 4px;
        padding: 17px 42px 20px 42px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;

        .main_classification_item {
          width: 60px;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;

          .banner_img {
            display: block;
            width: 60px;
            height: auto;
            max-height: 60px;
          }

          .title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            width: 100%;
            margin-top: 12px;
            font-size: 14px;
            font-family: 'PingFangSC-Regular';
            color: #000;
          }
        }
      }
    }
  }
}

.recommend_box {
  width: 100%;
  margin-top: 18px;

  .recommend_box_item {
    margin-bottom: 24px;

    .recommend_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;

      .title {
        font-family: 'PingFangSC-Semibold';
        font-weight: bold;
        font-size: 18px;
        color: #000;
      }

      .text {
        cursor: pointer;
        color: #666;
        font-size: 14px;
        font-family: 'PingFangSC-Regular';
      }

      .hoverStyles:hover {
        .text {
          color: @subject_color;
          text-decoration: underline;
        }

        .forward_icon_styles {
          color: @subject_color;
        }
      }
    }

    .recommend_content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .recommend_content_item {
        width: 228px;
        height: 298px;
        background-color: #fff;
        cursor: pointer;
        margin: 0 15px 15px 0;
        position: relative;

        .img_box_styles {
          width: 228px;
          height: 228px;
          overflow: hidden;
          display: inline-block;
        }

        .title {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          color: #000;
          font-size: 14px;
          font-family: 'PingFangSC-Regular';
          padding: 0 8px;
          margin: 6px 0 8px 0;
        }

        .price {
          font-family: 'PingFangSC-Semibold';
          padding: 0 8px;
          font-size: 14px;
          font-weight: 600;
          color: #000;
        }

        .original_price_style {
          color: #8D8D8D;
          text-decoration: line-through;
          padding-left: 5px;
          font-weight: normal;
          padding-right: 8px;
        }

        &:hover {
          box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1500);
        }
      }

      .recommend_content_item:nth-child(5n+5) {
        margin-right: 0;
      }
    }
  }

  .recommend_box_set {
    background-color: #ffffff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 6px;

    .recommend_title {
      border-bottom: 2px solid #6eaf39;
      padding: 0 18px;
    }

    .recommend_content {
      width: 100%;
      padding: 18px;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;

      .recommend_content_item {
        width: 176px;
        height: 240px;
        background-color: #fff;
        cursor: pointer;
        margin: 0 15px 15px 0;
        position: relative;

        .img_box_styles {
          width: 176px;
          height: 176px;
          border: solid 1px #e8e8e8;
          overflow: hidden;
          display: inline-block;
        }
      }
    }
  }
}

.activity_label_box {
  position: absolute;
  top: 0px;
  left: 0;
  display: flex;
  flex-direction: column;
  z-index: 100;

  .activity_label_item {
    color: #fff;
    font-size: 12px;
    border-bottom-right-radius: 15px;
    padding: 2px 8px;
    display: inline-block;
    margin-bottom: 8px;
  }
}
</style>
